module.exports = __webpack_public_path__ + "static/attractions-1.5c1736d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/attractions-1.jpg
// module id = 483
// module chunks = 249749550194671